import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

const getBaseUrl = ({ version }) =>
  `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/vibe-coding`;

export const fetchVibeRunState = async (args = {}) => {
  const data = args.data || args;
  const conversationId = args.conversationId || data.conversationId;
  const response = await axios.get(
    `${getBaseUrl(args)}/conversations/${conversationId}/run-state`,
    builderSurfaceJsonContentHeader(args.projectId),
  );
  return response.data;
};
